var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ app : !_vm.isMobile(), appMobile : _vm.isMobile() },style:(_vm.backgroundColorStyle),attrs:{"id":"app"}},[_c('router-view'),(_vm.isGrayMaskVisible)?_c('div',{staticClass:"gray-mask-window"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }